import Client from "../client";
import { ProjectFolderDefault } from "@/api/project/project-folder-default-api";
import FolderDefaultGateway from "@/usecases/gateways/folder-default-gateway";
import { FolderDefaultId } from "@/entities/ids";

export default class ProjectFolderDefaultApi implements FolderDefaultGateway {
  public constructor(private client: Client) {}

  public async all(): Promise<ProjectFolderDefault[]> {
    const list = await this.client.get("get_all_service_folder_default.php");
    return list.map(toFolderDefault);
  }

  public async save(keys: ProjectFolderDefault) {
    const d = new FormData();
    d.append("id", String(keys.id));
    d.append("name", keys.name);
    d.append("type", keys.type || "");
    await this.client.post("create_service_folder_default.php", d);
  }

  public async remove(id: FolderDefaultId) {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_service_folder_default.php", d);
  }

  public async sort(ids: FolderDefaultId[]) {
    const d = new FormData();
    ids.forEach((id, i) => {
      d.append(`ids[${i}]`, String(id));
    });
    await this.client.post("sort_service_folder_default.php", d);
  }
}

function toFolderDefault(t: any): ProjectFolderDefault {
  return {
    id: t.id,
    name: t.name,
    type: t.type
  };
}
